import React, { useContext, useEffect, useRef, useState } from "react";
import "../../styles/projectsOverview.css";
import LoadingIcon from "../../images/Loading_icon.gif";
import POWithFilter from "./POWithFilter";
import POFilter from "./POFilter";
import POSingleProject from "./POSingleProject";
import Swal from "sweetalert2";
import { AppContext } from "../../contexts/AppContext";
import { FilterContext } from "../../contexts/FilterContext";

export default function POContainer({
  refreshAfterFilter,
  setRefreshAfterFilter,
}) {
  const {
    projects,
    users,
    owners,
    error,
    setPage,
    loading,
    setProjectWithFilter,
    stopLoading,
  } = useContext(AppContext);
  const {
    searchInput,
    setSearchInput,
    zohoIdFilter,
    setZohoIdFilter,
    statusFilter,
    setStatusFilter,
    prjTypeFilter,
    setPrjTypeFilter,
    regionFilter,
    setRegionFilter,
    countryFilter,
    setCountryFilter,
    industryFilter,
    setIndustryFilter,
    ownerFilter,
    setOwnerFilter,
    filterPage,
    setFilterPage,
    filterUsed,
    setFilterUsed,
  } = useContext(FilterContext);

  useEffect(() => {
    if (
      !searchInput &&
      !zohoIdFilter &&
      !statusFilter &&
      !prjTypeFilter &&
      !regionFilter &&
      !countryFilter &&
      !industryFilter &&
      !ownerFilter
    ) {
      setProjectWithFilter([]);
    }
  }, [
    searchInput,
    zohoIdFilter,
    statusFilter,
    prjTypeFilter,
    regionFilter,
    countryFilter,
    industryFilter,
    ownerFilter,
    filterPage,
    filterUsed,
  ]);
  const [loadMoreProjects, setLoadMoreProjects] = useState(true);

  // const [page, setPage] = useState(1);
  const bottomRef = useRef(null);
  const [waitFivesec, setWaitFivesec] = useState(true);
  const [noMoreProjects, setNoMoreProjects] = useState(false);

  useEffect(() => {
    if (refreshAfterFilter) {
      setRefreshAfterFilter(true);
      setFilterPage(1);
      setLoadMoreProjects(true);
      setNoMoreProjects(false);
      setFilterUsed(false);
      setWaitFivesec(true);
      setRefreshAfterFilter(false);
    }
  }, [refreshAfterFilter]);

  useEffect(() => {
    if (
      searchInput ||
      zohoIdFilter ||
      statusFilter ||
      ownerFilter ||
      prjTypeFilter ||
      regionFilter ||
      countryFilter ||
      industryFilter
    ) {
      setFilterUsed(true);
    } else if (
      filterUsed &&
      !(
        searchInput ||
        zohoIdFilter ||
        statusFilter ||
        ownerFilter ||
        prjTypeFilter ||
        regionFilter ||
        countryFilter ||
        industryFilter
      )
    ) {
      setRefreshAfterFilter(true);
    }
  }, [
    searchInput,
    zohoIdFilter,
    statusFilter,
    ownerFilter,
    prjTypeFilter,
    regionFilter,
    countryFilter,
    industryFilter,
  ]);

  useEffect(() => {
    if (
      loadMoreProjects &&
      !(
        searchInput ||
        zohoIdFilter ||
        statusFilter ||
        ownerFilter ||
        prjTypeFilter ||
        regionFilter ||
        countryFilter ||
        industryFilter
      )
    ) {
      setLoadMoreProjects(false);

      // if (projects?.length > 0) {
      //   setLoading(false);
      // } else {
      //   setNoMoreProjects(true);
      // }

      if (error) {
        Swal.fire({
          icon: "error",
          title: "Database connection error!",
          text: "Please logout and try again.",
          confirmButtonText: "OK",
        });
        console.log(error);
      }
    }
  }, [projects, error]);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        setWaitFivesec(true);
        setPage((prevPage) => prevPage + 1);
        setLoadMoreProjects(true);
      }
    });

    if (bottomRef.current) {
      observer.observe(bottomRef.current);
    }

    return () => {
      if (bottomRef.current) {
        observer.unobserve(bottomRef.current);
      }
    };
  }, [bottomRef, projects]);

  useEffect(() => {
    if (waitFivesec) {
      setTimeout(() => {
        setWaitFivesec(false);
      }, 4000);
    }
  }, [waitFivesec]);

  if (
    searchInput ||
    zohoIdFilter ||
    statusFilter ||
    ownerFilter ||
    prjTypeFilter ||
    regionFilter ||
    countryFilter ||
    industryFilter
  ) {
    return (
      <div>
        <div className="project-overview-table container-div">
          <POFilter
            searchInput={searchInput}
            setSearchInput={setSearchInput}
            zohoIdFilter={zohoIdFilter}
            setZohoIdFilter={setZohoIdFilter}
            statusFilter={statusFilter}
            setStatusFilter={setStatusFilter}
            ownerFilter={ownerFilter}
            setOwnerFilter={setOwnerFilter}
            prjTypeFilter={prjTypeFilter}
            setPrjTypeFilter={setPrjTypeFilter}
            regionFilter={regionFilter}
            setRegionFilter={setRegionFilter}
            countryFilter={countryFilter}
            setCountryFilter={setCountryFilter}
            industryFilter={industryFilter}
            setIndustryFilter={setIndustryFilter}
            owners={owners}
          />

          <POWithFilter
            searchInput={searchInput}
            zohoIdFilter={zohoIdFilter}
            statusFilter={statusFilter}
            ownerFilter={ownerFilter}
            filterPage={filterPage}
            prjTypeFilter={prjTypeFilter}
            regionFilter={regionFilter}
            countryFilter={countryFilter}
            industryFilter={industryFilter}
            setFilterPage={setFilterPage}
            users={users}
          />
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="project-overview-table container-div">
        <POFilter
          searchInput={searchInput}
          setSearchInput={setSearchInput}
          zohoIdFilter={zohoIdFilter}
          setZohoIdFilter={setZohoIdFilter}
          statusFilter={statusFilter}
          setStatusFilter={setStatusFilter}
          ownerFilter={ownerFilter}
          setOwnerFilter={setOwnerFilter}
          prjTypeFilter={prjTypeFilter}
          setPrjTypeFilter={setPrjTypeFilter}
          regionFilter={regionFilter}
          setRegionFilter={setRegionFilter}
          countryFilter={countryFilter}
          setCountryFilter={setCountryFilter}
          industryFilter={industryFilter}
          setIndustryFilter={setIndustryFilter}
          owners={owners}
        />

        {loading && !projects.length ? (
          <div style={{ textAlign: "center", marginTop: "50px" }}>
            <img
              src={LoadingIcon}
              style={{ height: "50px" }}
              alt="Loading projects..."
            />
            {!projects.length > 0 && (
              <h4 style={{ marginTop: "20px" }}>please wait</h4>
            )}
          </div>
        ) : (
          projects.map((project) => {
            return (
              <div className="flex items-center justify-center">
                <div className="w-[97%]">
                  <POSingleProject
                    key={project.id}
                    project={project}
                    users={users}
                    filtering={false}
                  />
                </div>
              </div>
            );
          })
        )}
        {loading && projects.length ? (
          <div style={{ textAlign: "center", marginTop: "50px" }}>
            <img
              src={LoadingIcon}
              style={{ height: "50px" }}
              alt="Loading projects..."
            />
            {!projects.length > 0 && (
              <h4 style={{ marginTop: "20px" }}>please wait</h4>
            )}
          </div>
        ) : null}
        {projects.length && !stopLoading ? <div ref={bottomRef}></div> : null}

        {/* {!noMoreProjects && (
          <>
            <div style={{ textAlign: "center", marginTop: "50px" }}>
              <img
                src={LoadingIcon}
                style={{ height: "50px" }}
                alt="Loading projects..."
              />
              {!projects.length > 0 && (
                <h4 style={{ marginTop: "20px" }}>please wait</h4>
              )}
            </div>
            {projects.length > 0 ? (
              <div
                ref={bottomRef}
                style={{ marginBottom: "200px", marginTop: "20px" }}
              >
                <h4 style={{ textAlign: "center" }}>please wait</h4>
              </div>
            ) : null}
          </>
        )} */}
      </div>
    </div>
  );
}
